import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API_BASE } from "../config/api"; // path same rakho

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      return alert("Email and Password required");
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // 🔥 ONLY ADDITION
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setLoading(false);
        return alert(data.message || "Login failed");
      }

      login(data.user);
      if (data.user.role === "admin") {
  navigate("/admin", { replace: true });
} else {
  navigate("/home", { replace: true });
}

    } catch {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2
      bg-gradient-to-br from-black via-gray-950 to-black text-white">

      {/* ================= LEFT INFO PANEL ================= */}
      <div className="hidden lg:flex flex-col justify-center px-20
        relative overflow-hidden
        bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">

        <div className="absolute inset-0
          bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.12),transparent_60%)]" />

        <div className="relative z-10 max-w-lg">
          <div className="mb-6 inline-flex items-center gap-2
            bg-black/40 border border-blue-500/30
            px-4 py-1.5 rounded-full text-sm text-blue-300">
            🔒 Secure • ⚡ Fast • 🎓 Exam-Ready
          </div>

          <h1 className="text-5xl font-extrabold leading-tight mb-6">
            CodemintX
          </h1>

          <p className="text-lg text-gray-300 mb-8">
            A modern coding platform designed for{" "}
            <span className="font-semibold text-white">
              students, institutions
            </span>{" "}
            and real-world technical assessments.
          </p>

          <div className="grid grid-cols-2 gap-4 text-sm text-gray-300">
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              🛡️ Secure code execution
            </div>
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              🧪 Hands-on labs & compiler
            </div>
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              📝 Exam-oriented tests
            </div>
            <div className="bg-black/40 rounded-xl p-4 border border-gray-800">
              📊 Progress tracking
            </div>
          </div>

          <p className="mt-10 text-sm text-gray-400 italic">
            Build skills. Prove knowledge. Grow confidently.
          </p>
        </div>
      </div>

      {/* ================= RIGHT LOGIN PANEL ================= */}
      <div className="flex items-center justify-center px-6">
        <div className="bg-gray-900/80 backdrop-blur
          p-8 rounded-2xl w-full max-w-md
          border border-gray-800 shadow-2xl">

          <h2 className="text-2xl font-bold mb-1 text-center">
            Welcome Back
          </h2>
          <p className="text-sm text-gray-400 mb-6 text-center">
            Login to continue
          </p>

          <input
            type="email"
            placeholder="Email address"
            className="w-full p-3 mb-4 bg-gray-800 rounded-lg outline-none
            focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 mb-6 bg-gray-800 rounded-lg outline-none
            focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            disabled={loading}
            onClick={handleLogin}
            className={`w-full py-3 rounded-lg font-semibold transition
            ${loading
              ? "bg-gray-600 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"}`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="text-sm text-gray-400 mt-4 text-center">
            Don&apos;t have an account?{" "}
            <Link to="/signup" className="text-blue-400 hover:underline">
              Sign up
            </Link>
          </p>

         <p className="text-xs text-gray-500 mt-2 text-center">
  Forgot your password?{" "}
  <Link to="/forgot" className="text-blue-400 hover:underline">
    Reset here
  </Link>
</p>

        </div>
      </div>
    </div>
  );
}
